/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventDayInfo,
    JsonEventDayInfoFromJSON,
    JsonEventDayInfoFromJSONTyped,
    JsonEventDayInfoToJSON,
} from './JsonEventDayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventDayInfo
 */
export interface ApiResultOfJsonEventDayInfo {
    /**
     * 
     * @type {JsonEventDayInfo}
     * @memberof ApiResultOfJsonEventDayInfo
     */
    data?: JsonEventDayInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventDayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventDayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventDayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventDayInfo
     */
    result?: ApiResultOfJsonEventDayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventDayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventDayInfoFromJSON(json: any): ApiResultOfJsonEventDayInfo {
    return ApiResultOfJsonEventDayInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventDayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventDayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventDayInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventDayInfoToJSON(value?: ApiResultOfJsonEventDayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventDayInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

